/**
 * Created by Seng Kiat on 22/07/2020.
 */
"use strict";

class SuperLeadsDetailsController {
    constructor($scope, $window, $timeout, $localStorage, $parse, SSHttpService, SSUtilService, SSAppService, SSUserService, SSAlertService, SSConfigService) {

        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.$timeout = $timeout;
        self.$storage = $localStorage;
        self.$parse = $parse;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSUserService = SSUserService;
        self.SSAlertService = SSAlertService;
        self.SSConfigService = SSConfigService;

        self.BUYER_ENQUIRY_TYPE_GENERAL = SHOWSUITE.BUYER_ENQUIRY_TYPE_GENERAL;
        self.BUYER_ENQUIRY_TYPE_DEVELOPER = SHOWSUITE.BUYER_ENQUIRY_TYPE_DEVELOPER;
        self.BUYER_ENQUIRY_TYPE_BROKER = SHOWSUITE.BUYER_ENQUIRY_TYPE_BROKER;
        self.BUYER_ENQUIRY_TYPE_THIRD_PARTY = SHOWSUITE.BUYER_ENQUIRY_TYPE_THIRD_PARTY;
        self.BUYER_ENQUIRY_TYPE_INTERNAL = SHOWSUITE.BUYER_ENQUIRY_TYPE_INTERNAL;
        self.BUYER_ENQUIRY_TYPE_BUYER = SHOWSUITE.BUYER_ENQUIRY_TYPE_BUYER;

        self.BUYER_ENQUIRY_STATUS_CREATED = SHOWSUITE.BUYER_ENQUIRY_STATUS_CREATED;
        self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENT = SHOWSUITE.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENT;
        self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENCY = SHOWSUITE.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENCY;
        self.BUYER_ENQUIRY_STATUS_VIEWED = SHOWSUITE.BUYER_ENQUIRY_STATUS_VIEWED;
        self.BUYER_ENQUIRY_STATUS_BOOKED = SHOWSUITE.BUYER_ENQUIRY_STATUS_BOOKED;
        self.BUYER_ENQUIRY_STATUS_EXERCISED = SHOWSUITE.BUYER_ENQUIRY_STATUS_EXERCISED;
        self.BUYER_ENQUIRY_STATUS_COMMISSION_PAID = SHOWSUITE.BUYER_ENQUIRY_STATUS_COMMISSION_PAID;

        self.VALUE_TYPE_PERCENTAGE = SHOWSUITE.VALUE_TYPE_PERCENTAGE;
        self.VALUE_TYPE_AMOUNT = SHOWSUITE.VALUE_TYPE_AMOUNT;

        self.USER_STATUS_PENDING = SHOWSUITE.USER_STATUS_PENDING;
        self.USER_STATUS_ACTIVE = SHOWSUITE.USER_STATUS_ACTIVE;
        self.USER_STATUS_INACTIVE = SHOWSUITE.USER_STATUS_INACTIVE;

        self.BUYER_TYPE_INDIVIDUAL = SHOWSUITE.BUYER_TYPE_INDIVIDUAL;
        self.BUYER_TYPE_COMPANY = SHOWSUITE.BUYER_TYPE_COMPANY;

        self.lead_types = [
            {id: self.BUYER_ENQUIRY_TYPE_GENERAL, name: "Organic"},
            {id: self.BUYER_ENQUIRY_TYPE_DEVELOPER, name: "Developer"},
            {id: self.BUYER_ENQUIRY_TYPE_BROKER, name: "Broker"},
            {id: self.BUYER_ENQUIRY_TYPE_THIRD_PARTY, name: "Third Party"},
            {id: self.BUYER_ENQUIRY_TYPE_INTERNAL, name: "Internal"},
            {id: self.BUYER_ENQUIRY_TYPE_BUYER, name: "Referrals"},
        ];

        self.selective_lead_types = [
            {id: self.BUYER_ENQUIRY_TYPE_THIRD_PARTY, name: "Third Party"},
            {id: self.BUYER_ENQUIRY_TYPE_INTERNAL, name: "Internal"},
        ];

        self.commission_types = [
            {id: self.VALUE_TYPE_PERCENTAGE, name: "Percentage"},
            {id: self.VALUE_TYPE_AMOUNT, name: "Amount"},
        ];

        self.statuses = {};
        self.statuses[self.USER_STATUS_PENDING] = 'Pending';
        self.statuses[self.USER_STATUS_ACTIVE] = 'Active';
        self.statuses[self.USER_STATUS_INACTIVE] = 'In-active';

        self.buyer_types = [
            {id: self.BUYER_TYPE_INDIVIDUAL, name: "Individual"},
            {id: self.BUYER_TYPE_COMPANY, name: "Company"},
        ];

        self.UNIT_CATEGORIES_MAP = {
            0: {code: 'XX', name: 'Other', className: 'empty'},
            1: {code: '1BR', name: '1 Bedroom', className: 'bed1'},
            2: {code: '2BR', name: '2 Bedroom', className: 'bed2'},
            3: {code: '3BR', name: '3 Bedroom', className: 'bed3'},
            4: {code: '4BR', name: '4 Bedroom', className: 'bed4'},
            5: {code: '5BR', name: '5 Bedroom', className: 'bed5'},
            6: {code: 'PH', name: 'Penthouse', className: 'ph'},
            7: {code: 'COM', name: 'Commercial', className: 'retail'},
            1000: {code: 'CT', name: 'Corner Terrace', className: 'corner-terrace'},
            2000: {code: 'IT', name: 'Intermediate Terrace', className: 'interlaced-terrace'},
            3000: {code: 'SD', name: 'Semi-Detached', className: 'semi-detached'},
            4000: {code: 'DE', name: 'Detached', className: 'detached'},
            4001: {code: 'SU', name: 'Storage Unit', className: 'retail'},
            4002: {code: 'WH', name: 'Warehouse', className: 'detached'},
        };
        self.availableUnits = [];
        self.floor_types = {};
        self.floor_plan_types = [];
        self.countries = [];

        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;
        self.UNIT_STATUS_SPECIAL_RESERVED = SHOWSUITE.UNIT_STATUS_SPECIAL_RESERVED;

        self.LEAD_COMMISSION_SETTINGS = SHOWSUITE.LEAD_COMMISSION_SETTINGS;
        self.lead_commission_default_obj = null;   // set by getDefaultCommission()

        self.params = {};
        jQuery('.datepicker').datepicker({
            dateFormat: "yy-mm-dd"
        });

        $(document).ready(function () {
            $('.modal').on("hidden.bs.modal", function (e) { //fire on closing modal box
                if ($('.modal:visible').length) { // check whether parent modal is opend after child modal close
                    $('body').addClass('modal-open'); // if open mean length is 1 then add a bootstrap css class to body of the page
                }
            });
        });

        self.SINGAPORE_SELECTOR_ID = 702;
        self.SSUserService.registerErrors = {};

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;
        self.getAllProperties();

        if (SHOWSUITE.data.lead_id) {
            self.lead_id = SHOWSUITE.data.lead_id;
            self.getLeadDetails();
        }
            
        self.getDefaultCommission();

        self.apiOffset = 0;
        self.apiLimit = 10;

        self.searchParams = {};
        self.entry = {};

        self.getBuyers();
        self.getAgencies();
        self.getAMPs();
        self.countries = self.SSConfigService.getCountries();
    }

    getUsers() {
        const self = this;

        self.users = null;

        let url = 'sec/super/users';
        self.searchParams.offset = self.apiOffset;
        self.searchParams.limit = self.apiLimit;

        loading(true);
        self.SSHttpService.postAPIRequest(url, self.searchParams).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.users = response.data.users;
            self.count = response.data.count;

            _.forEach(self.users, function (user) {
                if (user.status == null) {
                    user.status = 0;
                }
            });

            self.pages = Math.ceil(self.count / self.apiLimit);
            self.selectedPage = Math.floor(self.apiOffset / self.apiLimit) + 1;
        });
    }

    getAgencies() {
        const self = this;

        let url = 'agencies';
        let params = {
            'offset': 0,
            'limit': 100,
            'format': 1
        };

        self.agencies = null;

        self.SSHttpService.getAPIRequest(url, params).then(function (responseObj) {

            if (responseObj instanceof Error) {
                return;
            }

            self.agencies = responseObj.data.agencies;
        });
    }

    getEntryStatus() {
        const self = this;

        if (self.entry.status == null)
            return self.statuses[0];

        return self.statuses[self.entry.status == true ? 1 : 2];
    }

    searchUsers() {
        const self = this;

        self.apiOffset = 0;
        self.selectedPage = 1;
        self.getUsers();
    }

    pagesGoBack() {
        const self = this;

        self.selectedPage--;
        self.apiOffset = self.apiOffset - self.apiLimit;
        self.getBuyers();
    }

    pagesGoNext() {
        const self = this;

        self.selectedPage++;
        self.apiOffset = self.apiOffset + self.apiLimit;
        self.getBuyers();
    }

    getStatus(user) {
        const self = this;

        if (!user.status) {
            if (!user.token)
                return "In-active";
            return "Pending";
        }
        return self.statuses[user.status];
    }

    togglePopup() {
        const self = this;

        self.detailsModal = !self.detailsModal;
        jQuery('#UserDetailsPopup').modal(jQuery('#UserDetailsPopup').is(':visible') ? 'hide' : 'show');
    }

    detailsPopup(user) {
        const self = this;

        self.entry = angular.copy(user);

        if (self.statuses[self.entry.status] == 'Pending')
            self.entry.status = null;
        else
            self.entry.status = self.statuses[self.entry.status] == 'Active' ? true : false;

        self.errorMessage = null;

        

        self.togglePopup();
    }

    maskPhoneNumber(context, contextPrefix, formId) {
        let self = this;
        if (!context) {
            return;
        }

        let parent = null;
        if (formId) {
            parent = jQuery('#' + formId);
        } else {
            parent = jQuery('body');
        }

        jQuery.each(parent.find('.tel'), function (i, el) {

            let field = jQuery(el);
            let allowDropdown = field.attr('allowDropdown');
            allowDropdown = !allowDropdown || allowDropdown !== 'false';

            field.intlTelInput({
                initialCountry: 'sg',
                geoIpLookup: self.SSUtilService.geoIpLookup,
                allowDropdown: allowDropdown,
                preferredCountries: ['sg']
            });

            let model = field.attr('ng-model');
            if (model) {
                if (startsWith(model, contextPrefix)) {
                    model = model.substring(contextPrefix.length);
                }
                let value = self.$parse(model)(context);

                if (value) {
                    field.intlTelInput('setNumber', value);
                } else {
                    field.val('');
                }
            }

            field.on("keyup change", function () {
                field.parent().removeClass("has-warning");
            });
            field.blur(function () {
                var currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                field.val(field.intlTelInput("getNumber", currentFormat));
                field.parent().removeClass("has-warning");
                if (!field.intlTelInput("isValidNumber")) {
                    field.parent().addClass("has-warning");
                    if (model) {
                        //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
                        document.getElementById('user_phone1').setCustomValidity("Invalid Contact Number");
                    }
                } else {
                    if (model) {
                        document.getElementById('user_phone1').setCustomValidity("");
                        self.$parse(model).assign(context, field.intlTelInput("getNumber"));
                        jQuery('#phone1-full').val(field.intlTelInput("getNumber"));
                    }
                }
            });
        });
    }

    hideModal() {
        const self = this;

        self.showChooseCustomerModal = false;
        self.showCreateCustomerModal = false;
        self.showChooseUnitModal = false;
        self.showChooseBuyerModal = false;
        self.showCreateBuyerModal = false;

        if ($('#chooseCustomerModal').is(':visible')) $('#chooseCustomerModal').modal('hide');
        if ($('#createCustomerModal').is(':visible')) $('#createCustomerModal').modal('hide');
        if ($('#chooseUnitModal').is(':visible')) $('#chooseUnitModal').modal('hide');
        if ($('#chooseBuyerModal').is(':visible')) $('#chooseBuyerModal').modal('hide');
        if ($('#createBuyerModal').is(':visible')) $('#createBuyerModal').modal('hide');
    }

    getAllProperties() {
        const self = this;

        let url = 'properties/customized';
        let params = {
            property_selected_fields: 'id, name, named_id',
            offset: 0,
            limit: 9999
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data.properties) {
                self.properties = response.data.properties;
            }

            self.$timeout(function() { $("select.dashboard-select").niceSelect('update'); });
        });
    }

    saveLead() {
        const self = this;

        if (!self.validateLead()) {
            self.SSAlertService.danger("Error!", "Please enter required fields.");
            return;
        }

        let url = 'sec/super/leads';

        loading(true);

        if (self.lead_id) {
            url = 'sec/super/leads/' + self.lead_id;
            self.SSHttpService.putAPIRequest(url, self.params).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self.SSAlertService.success("Success!", "Updated lead!");
                self.$window.location.href = '/super/leads';
            });
        } else {
            self.SSHttpService.postAPIRequest(url, self.params).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self.SSAlertService.success("Success!", "Created a new lead!");
                self.$window.location.href = '/super/leads';
            });
        }
    }

    validateLead() {
        const self = this;

        let validate = true;
        self.errors = {};

        if (!self.params.property_id) {
            self.errors.property_id = "Please select a project.";
            validate = false;
        }
        if (!self.params.type) {
            self.errors.type = "Please select a lead type.";
            validate = false;
        } else if (self.params.type == self.BUYER_ENQUIRY_TYPE_THIRD_PARTY && !self.params.amp_id) {
            self.errors.type = "Please select AMP.";
            validate = false;
        }
        if (!self.params.buyer_id) {
            self.errors.buyer_id = "Please select a customer.";
            validate = false;
        }
        if (!self.params.txt_message) {
            self.errors.txt_message = "Please enter messages.";
            validate = false;
        } else if (self.params.txt_message.length > 1000) {
            self.errors.txt_message = "Please enter less than 1000 characters.";
            validate = false;
        }

        if ((!self.params.showsuite_commission_type && self.params.showsuite_commission_value) || (self.params.showsuite_commission_type && !self.params.showsuite_commission_value)) {
            self.errors.showsuite_commission_value = "Please select Showsuite Commission Type and enter Showsuite Commission Value.";
            validate = false;
        }

        if ((!self.params.amp_commission_type && self.params.amp_commission_value) || (self.params.amp_commission_type && !self.params.amp_commission_value)) {
            self.errors.amp_commission_value = "Please select Third Party Commission Type and enter Third Party Commission Value.";
            validate = false;
        }

        return validate;
    }

    selectCustomer() {
        const self = this;

        self.hideModal();

        self.showChooseCustomerModal = true;
        $('#chooseCustomerModal').modal('show');
    }

    chooseCustomer(user) {
        const self = this;

        self.hideModal();

        self.selected_buyer = user;
        self.params.buyer_id = user.id;
    }

    prepareCreateUser() {
        const self = this;

        self.hideModal();

        self.showCreateCustomerModal = true;
        $('#createCustomerModal').modal('show');

        self.maskPhoneNumber(self, 'ctrl.', 'createCustomerModal');
    }

    createNewUser() {
        const self = this;

        if (!self.validateCreateUser()) {
            return;
        }

        let url = 'sec/super/leads/customer';

        loading(true);
        self.SSHttpService.postAPIRequest(url, self.SSUserService.registerParams).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                if (response.data.email) {
                    self.SSUserService.registerErrors.email = response.data.email[0];
                    return;
                }

                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.selected_buyer = response.data;
            self.params.buyer_id = response.data.id;

            self.SSAlertService.success("Success!", "Created a new user!");
            self.hideModal();
        });
    }

    validateCreateUser() {
        const self = this;

        let validate = true;
        self.SSUserService.registerErrors = {};

        if (!self.SSUserService.registerParams.first_name) {
            self.SSUserService.registerErrors.first_name = "Please enter First Name";
            validate = false;
        }
        if (!self.SSUserService.registerParams.last_name) {
            self.SSUserService.registerErrors.last_name = "Please enter Last Name";
            validate = false;
        }
        if (!self.SSUserService.registerParams.email) {
            self.SSUserService.registerErrors.email = "Please enter Email";
            validate = false;
        }

        return validate;
    }

    getLeadDetails() {
        const self = this;

        let url = 'sec/super/leads/' + self.lead_id;
        let param = {
            include: 'properties, units, users, brokers, agencies, buyers'
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url, param).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data.leads && response.data.leads.length > 0) {
                let lead = response.data.leads[0];
                self.params.property_id = lead.property_id;
                if (lead.unit_id) {
                    let found_unit = response.data.units.find(x => x.id == lead.unit_id);
                    if (found_unit) {
                        self.params.unit_id = found_unit.named_id;
                        self.selected_unit = found_unit;
                    }
                }
                self.params.type = lead.type;
                self.params.amp_id = lead.amp_id;
                if (lead.buyer_id) {
                    let found_user = response.data.buyers.find(x => x.id == lead.buyer_id);
                    if (found_user) {
                        self.params.buyer_id = found_user.id;
                        self.selected_buyer = found_user;
                    }
                }
                
                self.params.broker_user_id = lead.broker_user_id;
                self.params.developer_id = lead.developer_id;
                self.params.status = lead.status;
                self.params.sale_price = lead.sale_price;
                self.params.broker_commission_amount = lead.broker_commission_amount;
                self.params.showsuite_commission_type = lead.showsuite_commission_type;
                self.params.showsuite_commission_value = lead.showsuite_commission_value;
                self.params.showsuite_commission_amount = lead.showsuite_commission_amount;
                self.params.amp_commission_type = lead.amp_commission_type;
                self.params.amp_commission_value = lead.amp_commission_value;
                self.params.amp_commission_amount = lead.amp_commission_amount;
                self.params.txt_message = lead.txt_message;
            }
        });
    }

    selectUnit() {
        const self = this;

        self.hideModal();

        // Initialize 'selectize' for floor plan filters
        self.initSelectizejs();

        self.getUnitStacks();
    }

    chooseUnit(unit) {
        const self = this;

        self.hideModal();

        self.selected_unit = unit;
        self.params.unit_id = unit.id;

        if (unit.price) {
            self.params.sale_price = unit.price;
        }
    }

    getUnitStacks() {
        const self = this;

        self.units = null;

        let url = 'properties/' + self.params.property_id + '/stacks';
        let params = {

            'return_property': true,
            'property_columns': 'id,named_id,name,type,product_type,status,location,country,region',
            'return_stack': true,
            'stack_columns': 'id,named_id,name',
            'include_units': true,
            'unit_columns': 'id,named_id,floor_no,unit_no,house_no,category,type,name,baths,status,price,start_price,end_price,size_ft2,psf'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.stacks = response.data.property_stacks;
            self.processServerData();
            self.getPropertyUnitTypes();

            self.showChooseUnitModal = true;
            $('#chooseUnitModal').modal('show');
        });
    }

    processServerData() {
        const self = this;

        jQuery.each(self.stacks, function (i, stack) {
            stack.floorsData = self.SSUtilService.getFloorWiseUnits(stack.units);
            stack.availableUnits = self.filterAvailableUnits(stack.units);
        });

        // Select first stack by default
        self.selectedStackId = (self.selectedStackId) ? self.selectedStackId : self.stacks[0].id;
    }

    filterAvailableUnits(units) {
        const self = this;

        let statuses = [self.UNIT_STATUS_LISTED, self.UNIT_STATUS_RESERVED, self.UNIT_STATUS_DRAFT, self.UNIT_STATUS_SOLD, self.UNIT_STATUS_BOOKED, self.UNIT_STATUS_SPECIAL_RESERVED];
        let filtered = [];

        _.each(units, function (unit) {
            if (statuses.indexOf(unit.status) !== -1) {
                unit["unit_num"] = self.getUnitNumber(unit);
                let stack = self.stacks.find(x => x.id == unit.stack_id);
                if(stack){
                    unit["block_no"] = stack.name;
                }
                filtered.push(unit);
                self.availableUnits.push({'unit_id': unit.id, 'unit_num': unit.unit_num, 'unit': unit});
            }
        });

        if (self.sortBy) {
            filtered = _.sortBy(filtered, function (item) {
                return item[self.sortBy];
            })
        }

        return filtered;
    }

    getPropertyUnitTypes() {
        const self = this;

        self.propertyUnitCategories = [];

        jQuery.each(self.stacks, function (i, stack) {
            jQuery.each(stack.units, function (j, unit) {
                let category = null;
                if (unit.category in self.UNIT_CATEGORIES_MAP) {
                    category = self.UNIT_CATEGORIES_MAP[unit.category];
                } else {
                    category = self.UNIT_CATEGORIES_MAP[0];
                }

                if (self.propertyUnitCategories.indexOf(category) == -1) {
                    self.propertyUnitCategories.push(category);
                }

                // Process floor plan data
                let floor_category = unit.floor_plan;

                if (self.floor_types.hasOwnProperty(floor_category)) {

                    self.floor_types[floor_category]["floor_units"].push(unit);

                } else {

                    self.floor_types[floor_category] = {};
                    self.floor_types[floor_category]["name"] = floor_category;
                    self.floor_types[floor_category]["floor_units"] = []
                    self.floor_types[floor_category]["floor_units"].push(unit);

                    self.floor_plan_types.push({'id': unit.floor_plan, 'name': unit.floor_plan});
                }
            });
        });
    }

    filterViewStack(className) {
        const self = this;

        var buttons = $("div.scroll").find("button");
        self.selected_class_name = className;

        //Make all visible
        var invisible_buttons = $("div.scroll").find("button.greyout");
        jQuery.each(invisible_buttons, function (i, button) {
            $(button).removeClass("greyout");
        });

        //Make all invisible other than className
        if (className) {
            jQuery.each(buttons, function (i, button) {
                if (!$(button).hasClass(className)) {
                    $(button).addClass("greyout");
                }
            });
        }
    }

    initSelectizejs() {
        const self = this;

        let $select = $('#selectize').selectize({
            delimiter: ',',
            persist: false,
            create: function (input) {
                return {
                    value: input,
                    text: input
                }
            }
        });
    }

    getUnitCellClass(unit) {
        const self = this;

        let cls = '';

        if (!unit.category) {
            cls = 'empty';
        } else if (unit.status == self.UNIT_STATUS_LISTED) {
            if (unit.category in self.UNIT_CATEGORIES_MAP) {
                cls = self.UNIT_CATEGORIES_MAP[unit.category].className;
            } else {
                cls = self.UNIT_CATEGORIES_MAP[0].className;
            }
        } else if (unit.status == self.UNIT_STATUS_SOLD) {
            cls = 'sold';
        } else if (unit.status == self.UNIT_STATUS_DRAFT) {
            cls = 'draft';
            //cls = self.UNIT_CATEGORIES_MAP[3].className;
        } else {
            cls = 'reserved';
        }

        return cls;
    }

    get360photoClass(unit) {
        if (unit.floor_plan_3d != null) {
            return '360photo';
        }
    }

    get3DFloorPlanClass(unit) {
        if (unit.floor_plan_3d != null) {
            return '3Dfloorplan';
        }
    }

    getUnitNumber(unit) {
        const self = this;

        if (unit.length < 1) {
            return '-';
        }
        return self.SSUtilService.getFullUnitNumber1(unit, true);
    }

    filterFloorPlan() {
        const self = this;

        let unit_types = self.floor_plan_type;

        if (unit_types.length > 0) {

            // Make all invisible
            var buttons = $("div.scroll").find("button");
            $(buttons).addClass("greyout");

            // Now make all visible for selected floor plan type
            for (var index = 0; index < unit_types.length; index++) {
                let type = self.floor_types[unit_types[index]];
                for (var j = 0; j < type.floor_units.length; j++) {
                    let unit = type.floor_units[j];
                    // Get unit button
                    let button = $('#' + unit.named_id)
                    if ($(button).hasClass("greyout")) {
                        $(button).removeClass("greyout");
                    }
                }
            }
        } else {
            //Make all visible
            var buttons = $("div.scroll").find("button");
            $(buttons).removeClass("greyout");
        }
    }

    selectBuyer() {
        const self = this;

        self.hideModal();

        self.showChooseBuyerModal = true;
        $('#chooseBuyerModal').modal('show');
    }

    chooseBuyer(buyer) {
        const self = this;

        self.hideModal();

        self.selected_buyer = buyer;
        self.params.buyer_id = buyer.id;
    }

    getBuyers() {
        const self = this;

        self.buyers = null;

        let url = 'sec/buyers';
        self.searchParams.include = "company, individual, email_contact, phone1_contact";
        self.searchParams.offset = self.apiOffset;
        self.searchParams.limit = self.apiLimit;
        self.searchParams.send_total_count = true;

        loading(true);
        self.SSHttpService.getAPIRequest(url, self.searchParams).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.buyers = response.data.buyers;
            self.count = response.data.total_count;

            self.pages = Math.ceil(self.count / self.apiLimit);
            self.selectedPage = Math.floor(self.apiOffset / self.apiLimit) + 1;
        });
    }

    searchBuyer() {
        const self = this;

        self.buyers = null;
        self.apiOffset = 0;
        self.selectedPage = 1;

        let url = 'sec/buyers/search';
        self.searchParams.filter_field = "email_contact_value";

        if (self.searchParams.filter_value == "" || self.searchParams.filter_value == null || self.searchParams.filter_value == undefined) {
            self.resetSearchBuyer();
        } else {
            loading(true);
            self.SSHttpService.getAPIRequest(url, self.searchParams).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self.buyers = [];

                if (response.data.buyer) {
                    self.buyers.push(response.data.buyer);
                }
                self.count = self.buyers.length;

                self.pages = Math.ceil(self.count / self.apiLimit);
                self.selectedPage = Math.floor(self.apiOffset / self.apiLimit) + 1;
            });
        }
    }

    resetSearchBuyer() {
        const self = this;

        self.searchParams.filter_value = "";

        self.apiOffset = 0;
        self.selectedPage = 1;
        self.getBuyers();
    }

    prepareCreateBuyer() {
        const self = this;

        self.hideModal();

        self.showCreateBuyerModal = true;
        $('#createBuyerModal').modal('show');
        self.SSUserService.registerParams = {};

        self.maskPhoneNumber(self, 'ctrl.', 'createBuyerModal');
        self.$timeout(function() { 
            $("select.dashboard-select").niceSelect('update');
        });
    }

    createNewBuyer() {
        const self = this;

        if (!self.validateCreateBuyer()) {
            return;
        }

        let url = 'sec/buyers';

        self.SSUserService.registerParams.individual_identity_type = "singaporean";
        self.SSUserService.registerParams.individual_national_id = "xxxx";
        self.SSUserService.registerParams.individual_nationality = 702;
        self.SSUserService.registerParams.type = self.BUYER_TYPE_INDIVIDUAL;

        loading(true);
        self.SSHttpService.postAPIRequest(url, self.SSUserService.registerParams).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                self.hideModal();
                if (response.data.email_contact_value) {
                    self.SSUserService.registerErrors.email_contact_value = response.data.email[0];
                    return;
                }

                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.params.buyer_id = response.data.buyer.id;

            url = 'sec/buyers/' + self.params.buyer_id;
            let params = {
                include: 'company, individual, email_contact, phone1_contact'
            }

            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.hideModal();
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self.selected_buyer = response.data.buyers[0];

                self.SSAlertService.success("Success!", "Created a new buyer!");
                self.hideModal();
            });
        });
    }

    validateCreateBuyer() {
        const self = this;

        let validate = true;
        self.SSUserService.registerErrors = {};

        // if (!self.SSUserService.registerParams.type) {
        //     self.SSUserService.registerErrors.type = "Please select Buyer Type";
        //     validate = false;
        // } else if (self.SSUserService.registerParams.type == self.BUYER_TYPE_INDIVIDUAL) {
            if (!self.SSUserService.registerParams.individual_first_name) {
                self.SSUserService.registerErrors.individual_first_name = "Please enter First Name";
                validate = false;
            }

            if (!self.SSUserService.registerParams.individual_last_name) {
                self.SSUserService.registerErrors.individual_last_name = "Please enter Last Name";
                validate = false;
            }

        //     self.SSUserService.registerParams.company_reg_no = null;
        //     self.SSUserService.registerParams.company_nationality = null;
        // } else {
        //     if (!self.SSUserService.registerParams.company_name) {
        //         self.SSUserService.registerErrors.company_name = "Please enter Company Name";
        //         validate = false;
        //     }

        //     self.SSUserService.registerParams.individual_identity_type = null;
        //     self.SSUserService.registerParams.individual_national_id = null;
        //     self.SSUserService.registerParams.individual_nationality = null;

        //     self.SSUserService.registerParams.company_reg_no = "xxxx";
        //     self.SSUserService.registerParams.company_nationality = 702;
        // }

        if (!self.SSUserService.registerParams.email_contact_value && !self.SSUserService.registerParams.phone1_contact_value) {
            self.SSUserService.registerErrors.email_contact_value = "Please enter Email or Mobile Number";
            self.SSUserService.registerErrors.phone1_contact_value = "Please enter Email or Mobile Number";
            validate = false;
        }

        return validate;
    }

    removeUnit() {
        const self = this;

        self.selected_unit = null;
        self.params.unit_id = "";
    }

    getAMPs() {
        const self = this;

        self.amp_list = [];

        let url = 'sec/super/amps';
        let param = {
            'response_type': 1
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, param).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.amp_list = response.data.amps;
            self.$timeout(function() { $("select.dashboard-select").niceSelect('update'); });
        });
    }

    /**
     * Prefill the Showsuite / AMP commission with the defaults from System Settings
     * (the lead_commission_settings row of GET sec/super/system-settings).
     *
     * @remarks WEB-4732: that read needs SS_SYSTEM_SETTINGS_VIEW (WEB-4725). Without the key
     *          the defaults are skipped quietly: no request, no alert, and the commission fields
     *          stay blank for manual entry. A 403004 (key revoked mid-session) is ignored the same way.
     */
    getDefaultCommission() {
        const self = this;

        if (!self.SSUserService.hasPermission('SS_SYSTEM_SETTINGS_VIEW')) {
            return;
        }

        let url = 'sec/super/system-settings';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                if (response.sub_code != 403004) {
                    self.SSAlertService.parseAndDisplayError(response);
                }
                return;
            }

            if (response.data.system_settings) {
                let lead_commission_default = response.data.system_settings.find(x => x.name == self.LEAD_COMMISSION_SETTINGS);

                if (lead_commission_default) {
                    self.lead_commission_default_obj = JSON.parse(lead_commission_default.value);

                    self.params.showsuite_commission_type = self.lead_commission_default_obj.showsuite_lead_commission_share[0].type;
                    self.params.showsuite_commission_value = self.lead_commission_default_obj.showsuite_lead_commission_share[0].value;
                    self.params.amp_commission_type = self.lead_commission_default_obj.amp_lead_commission_share[0].type;
                    self.params.amp_commission_value = self.lead_commission_default_obj.amp_lead_commission_share[0].value;
                }
            }
        });
    }

    /**
     * Apply the project's (and, for a third-party lead, the AMP's) default commission once a
     * project or AMP is picked.
     *
     * @remarks WEB-4732: does nothing when the defaults were not loaded (no SS_SYSTEM_SETTINGS_VIEW),
     *          so the commission typed by hand is kept.
     */
    updateDefaultCommission() {
        const self = this;

        if (!self.lead_commission_default_obj) {
            return;
        }

        if (self.params.property_id) {
            let showsuite_commission_obj = self.lead_commission_default_obj.showsuite_lead_commission_share.find(x => x.property_id == self.params.property_id);

            if (showsuite_commission_obj) {
                self.params.showsuite_commission_type = showsuite_commission_obj.type;
                self.params.showsuite_commission_value = showsuite_commission_obj.value;
                self.updateShowsuiteCommissionAmount();
            }
            
            if (self.params.type == self.BUYER_ENQUIRY_TYPE_THIRD_PARTY && self.params.amp_id) {
                let amp_commission_obj = self.lead_commission_default_obj.amp_lead_commission_share.find(x => x.property_id == self.params.property_id && x.amp_id == self.params.amp_id);

                if (amp_commission_obj) {
                    self.params.amp_commission_type = amp_commission_obj.type;
                    self.params.amp_commission_value = amp_commission_obj.value;
                    self.updateAMPCommissionAmount();
                }
            }

            self.$timeout(function() { $("select.dashboard-select").niceSelect('update'); });
        }
    }

    updateCommissionAmount() {
        const self = this;

        self.updateShowsuiteCommissionAmount();
        self.updateAMPCommissionAmount();
    }

    updateShowsuiteCommissionAmount() {
        const self = this;

        if (self.params.showsuite_commission_type == self.VALUE_TYPE_PERCENTAGE && self.params.broker_commission_amount) {
            self.params.showsuite_commission_amount = self.params.showsuite_commission_value / 100 * self.params.broker_commission_amount;
        } else if (self.params.showsuite_commission_type == self.VALUE_TYPE_AMOUNT) {
            self.params.showsuite_commission_amount = self.params.showsuite_commission_value;
        }
    }

    updateAMPCommissionAmount() {
        const self = this;

        if (self.params.amp_commission_type == self.VALUE_TYPE_PERCENTAGE && self.params.showsuite_commission_amount) {
            self.params.amp_commission_amount = self.params.amp_commission_value / 100 * self.params.showsuite_commission_amount;
        } else if (self.params.amp_commission_type == self.VALUE_TYPE_AMOUNT) {
            self.params.amp_commission_amount = self.params.amp_commission_value;
        }
    }

    searchAddress() {
        const self = this;

        self.SSUserService.registerErrors["primary_address_postcode"] = null;

        if (!self.SSUserService.registerParams["primary_address_postcode"] || self.SSUserService.registerParams["primary_address_postcode"] == "" || self.SSUserService.registerParams["primary_address_postcode"] == null) {
            self.SSUserService.registerErrors["primary_address_postcode"] = "Please enter postal code to search";
            return;
        } else {
            if (self.SSUserService.registerParams["primary_address_postcode"].length != 6) {
                self.SSUserService.registerErrors["primary_address_postcode"] = "Please enter the correct postal code format to search";
                return;
            }
        }

        self.SSHttpService.getAddressFromPostcode(self.SSUserService.registerParams["primary_address_postcode"], function(result) {
            self.$timeout(function () {
                if (result) {
                    // Update address
                    self.SSUserService.registerParams["primary_address_line1"] = result.BLK_NO;
                    if (result.BUILDING === "NIL" || result.BUILDING === "") {
                        self.SSUserService.registerParams["primary_address_line2"] = result.ROAD_NAME;
                    } else {
                        self.SSUserService.registerParams["primary_address_line2"] = result.ROAD_NAME + ", " + result.BUILDING;
                    }

                    self.SSUserService.registerParams["primary_address_district"] = "";
                    self.SSUserService.registerParams["primary_address_city"] = "Singapore";
                } else {
                    self.SSUserService.registerErrors["primary_address_postcode"] = "Invalid postcode, please try again.";
                }
            });
        });
    }
}

SuperLeadsDetailsController.$inject = ['$scope', '$window', '$timeout', '$localStorage', '$parse', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSUserService', 'SSAlertService', 'SSConfigService'];
app.controller('SuperLeadsDetailsController', SuperLeadsDetailsController);

